import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SaleDepositReportTable from "../components/SaleDepositReport/Table";
import BranchDaySummaryTable from "../components/SaleDepositReport/BranchSummaryTable";
import SaleDepositReportTabs, {
  SALE_DEPOSIT_REPORT_TITLE,
} from "../components/SaleDepositReport/ReportTabs";
import { SALE_DEPOSIT_REPORT_PATH } from "../components/SaleDepositReport/depositReportUrl";
import { featureAccess } from "../permissions/access";
import { useUserRole } from "../utils/hooks/useUserRole";

export default function SaleDepositReportPage() {
  const role = useUserRole();
  /**
   * Who gets which altitude.
   *
   * A cross-branch reader opens on the branch-day summary and drills into one branch at a
   * time — that is how head office works the report, and one row per route of every branch
   * was 64 rows for two days' worth of the same information.
   *
   * A branch-scoped reader keeps the route-level table exactly as it is. Their summary would
   * be a single row per day: strictly less than what they have today, and it would hide the
   * routes they are there to tick off.
   */
  const showsBranchDaySummary = featureAccess.saleDepositBranchSummary(role);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Stack mb={2}>
        <Typography variant="h6">{SALE_DEPOSIT_REPORT_TITLE}</Typography>
        <SaleDepositReportTabs current={SALE_DEPOSIT_REPORT_PATH} />
      </Stack>
      {showsBranchDaySummary ? (
        <BranchDaySummaryTable />
      ) : (
        <SaleDepositReportTable />
      )}
    </Box>
  );
}
